//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocalizationInfo } from './LocalizationInfo';
import { PaymentProcessorDisplayItem } from './PaymentProcessorDisplayItem';
import { PaymentSurchargeDisplayItem } from './PaymentSurchargeDisplayItem';

export class SchoolSettingsDisplayItem extends ItemBase {
    LocalizationInfo: LocalizationInfo | null = null;
    SchoolName: string | null = null;
    SchoolAddress: string | null = null;
    IsMultiTeacher: boolean = false;
    SchoolActive: boolean = false;
    LogoUrl: string | null = null;
    InvoiceAccentColor: string | null = null;
    DefaultPaymentProcessor: PaymentProcessorDisplayItem | null = null;
    CurrencyCode: string | null = null;
    PaymentSurchargeACH: PaymentSurchargeDisplayItem | null = null;
    PaymentSurchargeCreditCard: PaymentSurchargeDisplayItem | null = null;
    ForceAutoPay: boolean = false;

    constructor(initializer?: Partial<SchoolSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolSettingsDisplayItem";
}
